import React from 'react';
import { cn } from './utils';
import './fields.css';

export const Textarea = React.forwardRef(({ className, ...props }, ref) => <textarea ref={ref}
  className={cn('pegasus-textarea sc-w-full sc-rounded-md sc-border sc-border-solid sc-border-border sc-bg-background sc-px-3 sc-py-2 sc-text-sm sc-text-foreground placeholder:sc-text-muted-foreground focus-visible:sc-outline-none focus-visible:sc-ring-2 focus-visible:sc-ring-ring disabled:sc-opacity-50', className)} {...props} />);
Textarea.displayName = 'Textarea';
